<bs-alert *msShowInEpcot="false" [type]="alertType" [message]="resultMessage()" />
<ms-epcot-notification *msShowInEpcot="true" [message]="resultMessage()" [notificationType]="'success'" />
